import FDAStatement from './FDAStatement.js';

export default FDAStatement;
